import type { MapPlaces, MinimapPlaceSpot } from "odyssey-shared";
import { placeMarks } from "../world-map/places.ts";

/**
 * The minimap's known places for a `mapPlaces` message: each place the character has found, named as the Map names it
 * (a shrine with no name of its own is the shrine word), in the order the server sent them. The server sends only the
 * places the character has found, so nothing undiscovered can pass through here.
 *
 * @param places The message's fields, or null before the first one and after the session's places are forgotten.
 * @returns The places in tiles; none for null.
 */
export function placeSpotsOf(places: MapPlaces | null): readonly MinimapPlaceSpot[] {
  if (places === null) {
    return [];
  }
  return placeMarks(places.places).map((mark) => ({ handle: mark.handle, name: mark.name, x: mark.x, y: mark.y }));
}
